import React from 'react';
import * as stylex from '@stylexjs/stylex';
import PageTitle from "nood-comp/src/comp/ui/containers/PageTitle";
import DomainSubNavigator2 from "nood-comp/src/comp/ui/nav/DomainSubNavigator2";
import PropertyEditor from "src/routes/app/property/PropertyEditor";
import Properties from "src/routes/app/property/Properties";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
export default function PropertyIndex(props) {
  var id = useURLParam("id");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PageTitle, {
    title: "Entity Properties",
    icon: "tag"
  }), /*#__PURE__*/React.createElement(DomainSubNavigator2, {
    queryFilter: "do",
    defaultHighlight: "list",
    menuItems: [{
      id: "list",
      label: "Properties",
      content: /*#__PURE__*/React.createElement(Properties, null),
      icon: "menu",
      queryString: {
        id: undefined
      }
    }, {
      id: "add",
      label: "Add",
      content: /*#__PURE__*/React.createElement(PropertyEditor, null),
      icon: "plus",
      queryString: {
        id: undefined
      }
    }, {
      id: "edit",
      label: "Edit",
      content: /*#__PURE__*/React.createElement(PropertyEditor, null),
      icon: "edit-2",
      show: id !== null
    }, {
      id: "view",
      label: "View",
      content: /*#__PURE__*/React.createElement(React.Fragment, null, "View Property"),
      icon: "eye",
      show: id !== null
    }]
  }));
}
PropertyIndex.propTypes = {
  // proptypes
};

// @ts-ignore